module.exports = __webpack_public_path__ + "img/location-marker.2a35491.png";